/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Language_LabelInputs */

const en_site_language_label = /** @type {(inputs: Site_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output language`)
};

const id_site_language_label = /** @type {(inputs: Site_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa hasil`)
};

/**
* | output |
* | --- |
* | "Output language" |
*
* @param {Site_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_language_label = /** @type {((inputs?: Site_Language_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Language_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_language_label(inputs)
	return en_site_language_label(inputs)
});